export interface AdminSession {
  readonly accessToken: string;
  readonly refreshToken: string;
}

const SESSION_KEY = 'jcy.admin.session.v1';
export const ADMIN_SESSION_CHANGED_EVENT = 'jcy:admin-session-changed';

export function getAdminSession(): AdminSession | null {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<AdminSession>;
    return typeof value.accessToken === 'string' && typeof value.refreshToken === 'string'
      ? { accessToken: value.accessToken, refreshToken: value.refreshToken }
      : null;
  } catch {
    return null;
  }
}

export function setAdminSession(session: AdminSession): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  notifySessionChanged();
}

export function clearAdminSession(): void {
  localStorage.removeItem(SESSION_KEY);
  notifySessionChanged();
}

function notifySessionChanged(): void {
  globalThis.dispatchEvent?.(new Event(ADMIN_SESSION_CHANGED_EVENT));
}
